import React from 'react';

import CouponCodeList from 'components/couponCode/CouponCodeList';

const CouponCodes = () => <CouponCodeList />;

export default CouponCodes;
